import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Users from './Users';

export default function Admin() {
  return (
    <>
      <div className="background-sun" />
      <Header />
      <main className="main-list">
        <div className="main main-list container" data-aos="fade-up" data-aos-delay="400" data-aos-duration="400">
          <Switch>
            <Route path="/admin/" component={Users} exact/>
          </Switch>
        </div>
      </main>
    </>
  )
}